import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Formik } from "formik";
import * as Yup from "yup";
import Socials from "../components/Socials";
import FormikInput from "../../../components/formik/Input";
import withMiddleware from "../../../middleware";
import { loginUserEmailPass, loginUserGoogle, loginUserApple } from "../../../actions";
import { useUtils } from "../../../utils";

const validationSchema = Yup.object({
  email: Yup.string().email("Invalid email address").required("Email is required"),
  password: Yup.string().min(6, "Password must be at least 6 characters").required("Password is required"),
});

function Login(props) {
  const { loading, setLoading } = props;
  const dispatch = useDispatch();
  const { showToast } = useUtils();

  const handleError = (error) => {
    setLoading(false);
    showToast("error", error?.message);
  };

  const handleSuccess = () => {
    // * Don't hide the loading state here because the wrapper does that when it fetches data
    // setLoading(false);
  };

  const handleGoogleSignIn = () => {
    setLoading(true);
    dispatch(loginUserGoogle(handleSuccess, handleError));
  };

  const handleAppleSignIn = () => {
    setLoading(true);
    dispatch(loginUserApple(handleSuccess, handleError));
  };

  return (
    <>
      <div className="form-wrapper">
        <div
          className="form-container sign-in-container"
          style={{
            pointerEvents: loading ? "none" : "auto",
          }}
        >
          <Formik
            initialValues={{ email: "", password: "" }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              setLoading(true);
              dispatch(loginUserEmailPass(handleSuccess, values["email"], values["password"], handleError));
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit} noValidate>
                <h1>Sign in</h1>
                <Socials handleGoogleSignIn={handleGoogleSignIn} handleAppleSignIn={handleAppleSignIn} />
                <span>or use your account</span>
                <FormikInput name="email" type="email" placeholder="Email" />
                <FormikInput name="password" type="password" placeholder="Password" />
                {/* <a href="#">Forgot your password?</a> */}
                <button type="submit" disabled={loading}>
                  Continue
                </button>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
}

export default withMiddleware(Login);
